import TagManager from 'react-gtm-module';
import { User } from 'pages/login';

interface TagManagerArgs {
  gtmId: string;
  dataLayer: {
    [key: string]: any;
  };
}

const tagManagerArgs: TagManagerArgs = {
  gtmId: 'GTM-KSM8LFF5',
  dataLayer: {},
};

export const initGA = () => {
  if (process.env.REACT_APP_ENV !== 'PROD') return;
  TagManager.initialize(tagManagerArgs);
};

export const getGAUserId = () => {
  try {
    const micUser = localStorage.getItem('mic-user');
    if (!micUser) return;

    const userInfo = JSON.parse(micUser) as User;
    if (userInfo?.user_id) {
      TagManager.dataLayer({
        dataLayer: {
          ...tagManagerArgs.dataLayer,
          member_id: userInfo.user_id,
          company_name: userInfo.company_name,
          user_role: userInfo.user_role,
        },
      });
    }
  } catch (error) {
    console.error('Error parsing user info from localStorage:', error);
  } finally {
    initGA();
  }
};

export const removeGAUserId = () => {
  try {
    TagManager.dataLayer({
      dataLayer: {
        ...tagManagerArgs.dataLayer,
        member_id: undefined,
        company_name: undefined,
        user_role: undefined,
      },
    });
  } catch (error) {
    console.error('Error removing user info from dataLayer:', error);
  } finally {
    initGA();
  }
};
